import { IconDefinition } from "./types";

/**
 * @deprecated Use `circleExclamation` instead. This icon will be removed in a future version.
 */
const error: IconDefinition = {
  iconName: "error",
  width: 512,
  height: 512,
  svgPathData:
    "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm28 332l-56 0 0-56 56 0 0 56zm-8.8-92l-38.4 0-12.8-160 64 0-12.8 160z",
  iconType: "fill",
  strokeWidth: 0,
  unicode: 0xf06a,
};

export { error };
